// extracted by css-extract-rspack-plugin
export default {"clamp":"NbuTu2THg4waTdTj","active":"iwphO2_vxIQmAqAa"};